import { hideModalOn } from './select2_modal'

// The line-item modal is loaded on demand and shown by the htmx-modal Stimulus
// controller. On a successful update the controller re-renders the list and
// fires closeLineItemModal (HX-Trigger); hiding it here lets htmx-modal remove
// it once hidden.
hideModalOn('closeLineItemModal', '#rfx-line-item-modal-placeholder .modal.show')
